export default function isLoadTest() { return process.env.REACT_APP_LOAD_TEST; }
